import React from 'react';

export default function EyebrowPill({ 
  children, 
  variant = 'dark',
  withStar = true,
  className = '',
}) {
  const variants = {
    dark: 'bg-warm-black text-gold-light',
    'gold-soft': 'bg-gold/15 text-brown',
    'gold-on-dark': 'bg-gold-light/20 text-gold-light',
    'cream-on-dark': 'bg-gold-light/18 text-gold-light',
  };
  
  return (
    <span className={`inline-flex items-center gap-2 px-[18px] py-2 rounded-pill text-eyebrow font-medium uppercase ${variants[variant] || variants.dark} ${className}`}>
      {withStar && <span>✦</span>}
      {children}
    </span>
  );
}